import type { TableColumns, TableTagMappings } from '@ohpen/enso-ui';

import type { ListRow, ValueRow } from './interfaces';

/** Every state the platform will give a value, so the filter reads the same before they arrive. */
export const STATUS_LIST_NAME = 'configValueStatuses';

export const listColumns: TableColumns<ListRow> = [
  {
    title: 'config.columns.id',
    dataIndex: 'id',
    key: 'id',
    width: 320,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.name',
    dataIndex: 'name',
    key: 'name',
    width: 180,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  { title: 'config.columns.values', dataIndex: 'count', key: 'count', width: 120, options: { sorter: true } },
];

export const valueColumns: TableColumns<ValueRow> = [
  { title: 'config.columns.order', dataIndex: 'order', key: 'order', width: 100 },
  {
    title: 'config.columns.code',
    dataIndex: 'code',
    key: 'code',
    width: 320,
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.label',
    dataIndex: 'label',
    key: 'label',
    width: 320,
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.status',
    dataIndex: 'status',
    key: 'status',
    width: 160,
    options: { format: { type: 'tag' }, listName: STATUS_LIST_NAME },
  },
];

export const getStatusTagMappings = (): TableTagMappings => ({
  status: {
    active: { color: 'green' },
    disabled: { color: 'orange' },
    hidden: { color: '' },
  },
});
